import { ToastService } from 'src/app/pages/dashboards/dashboard/toast-service';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/core/models/user';
import { Campaign } from '../../../../../core/models/campaign';
import { CampaignCriteria } from 'src/app/core/models/Campaign_Criterias';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { getFirebaseBackend } from 'src/app/authUtils';
import { CriteriaService } from 'src/app/services/criteria/criteria.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { STATES } from 'src/app/shared/constants';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';

@Component({
	selector: 'app-campaign-criteria',
	templateUrl: './campaign-criteria.component.html',
	styleUrls: ['./campaign-criteria.component.scss'],
})
export class CampaignCriteriaComponent implements OnInit {
	@Input() campaign: Campaign;

	public user: User = null;
	public criteriaTypes: any[] = [
		{ description: 'Employee Size', selected: false },
		{ description: 'Asset Size', selected: false },
		{ description: 'Plan Particpants', selected: false },
		{ description: 'State', selected: false },
		{ description: 'Zip Code', selected: false },
	];

	public criterias: CampaignCriteria;
	public criteriasLimits: any;
	public formCriteria: FormGroup;
	public states: any[];

	//Table
	columnMode = ColumnMode;
	rowsStates = [];
	loading = false;

	constructor(private dataService: OldDataService, public utils: UtilsService, public criteriaService: CriteriaService, public toastSrv: ToastService) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.states = STATES;
		this.criterias = {
			asset_size_max: 0,
			asset_size_min: 0,
			employee_size_max: 0,
			employee_size_min: 0,
			state: '',
			zip_code: '',
			radius: 0,
			plan_participants_min: 0,
			plan_participants_max: 0,
			prospects_from: 'LMS',
		};

		this.formCriteria = new FormGroup({
			asset_size_max: new FormControl(''),
			asset_size_min: new FormControl(''),
			employee_size_max: new FormControl(''),
			employee_size_min: new FormControl(''),
			plan_participants_max: new FormControl(''),
			plan_participants_min: new FormControl(''),
			state: new FormControl(''),
			zip_code: new FormControl(''),
			radius: new FormControl(''),
		});

		this.criteriasLimits = {
			employee_size: false,
			plan_participants: false,
			asset_size: false,
		};
	}

	ngOnInit(): void {
		this.getcriterias();
		this.getCriteriaStates();
	}

	criteriaSelected(criteria) {
		switch (criteria) {
			case 'employee_size':
				this.criterias.section_employee_size = !this.criterias.section_employee_size;
				if (this.criterias.section_employee_size) {
					this.formCriteria.get('employee_size_min').addValidators(Validators.required);
				} else {
					this.formCriteria.get('employee_size_min').removeValidators(Validators.required);
				}
				break;

			case 'asset_size':
				this.criterias.section_asset_size = !this.criterias.section_asset_size;
				if (this.criterias.section_asset_size) {
					this.formCriteria.get('asset_size_min').addValidators(Validators.required);
				} else {
					this.formCriteria.get('asset_size_min').removeValidators(Validators.required);
				}
				break;

			case 'plan_participants':
				this.criterias.section_plan_participants = !this.criterias.section_plan_participants;
				if (this.criterias.section_plan_participants) {
					this.formCriteria.get('plan_participants_min').addValidators(Validators.required);
				} else {
					this.formCriteria.get('plan_participants_min').removeValidators(Validators.required);
				}
				break;

			case 'state':
				this.criterias.section_state = !this.criterias.section_state;
				if (this.criterias.section_state) {
					this.formCriteria.get('state').addValidators(Validators.required);
				} else {
					this.formCriteria.get('state').removeValidators(Validators.required);
				}
				break;

			case 'zip_code':
				this.criterias.section_zip_code= !this.criterias.section_zip_code;
				if (this.criterias.section_zip_code) {
					this.formCriteria.get('zip_code').addValidators([Validators.required, Validators.maxLength(5)]);
					this.formCriteria.get('radius').addValidators(Validators.required);
				} else {
					this.formCriteria.get('zip_code').removeValidators([Validators.required, Validators.maxLength(5)]);
					this.formCriteria.get('radius').removeValidators(Validators.required);
				}
				break;
		}
	}

	limitSelected(criteria: string) {
		switch (criteria) {
			case 'employee_size':
				this.criteriasLimits.employee_size = !this.criteriasLimits.employee_size;
				if (this.criteriasLimits.employee_size) {
					this.formCriteria.get('employee_size_max').setValue(0);
				} else {
					this.formCriteria.get('employee_size_max').setValue(900000000);
				}
				break;

			case 'asset_size':
				this.criteriasLimits.asset_size = !this.criteriasLimits.asset_size;
				if (this.criteriasLimits.asset_size) {
					this.formCriteria.get('asset_size_max').setValue(0);
				} else {
					this.formCriteria.get('asset_size_max').setValue(900000000);
				}
				break;

			case 'plan_participants':
				this.criteriasLimits.plan_participants = !this.criteriasLimits.plan_participants;
				if (this.criteriasLimits.plan_participants) {
					this.formCriteria.get('plan_participants_max').setValue(0);
				} else {
					this.formCriteria.get('plan_participants_max').setValue(900000000);
				}
				break;
		}
	}

	getcriterias() {
		this.criteriaService.getCampaignCriterias(this.campaign.id).subscribe((data: any) => {
			this.criterias = data.body;
			this.formCriteria.get('asset_size_max').setValue(this.criterias.asset_size_max);
			this.formCriteria.get('asset_size_min').setValue(this.criterias.asset_size_min);
			this.formCriteria.get('employee_size_max').setValue(this.criterias.employee_size_max);
			this.formCriteria.get('employee_size_min').setValue(this.criterias.employee_size_min);
			this.formCriteria.get('plan_participants_max').setValue(this.criterias.plan_participants_max);
			this.formCriteria.get('plan_participants_min').setValue(this.criterias.plan_participants_min);
			this.formCriteria.get('zip_code').setValue(this.criterias.zip_code);
			this.formCriteria.get('radius').setValue(this.criterias.radius);

			if (this.criterias.asset_size_max != 900000000) {
				this.criteriasLimits.asset_size = true;
			}
			if (this.criterias.employee_size_max != 900000000) {
				this.criteriasLimits.employee_size = true;
			}
			if (this.criterias.plan_participants_max != 900000000) {
				this.criteriasLimits.plan_participants = true;
			}
		});
	}

	saveCriterias() {
		const criterias = this.formCriteria.getRawValue();
		this.criterias.asset_size_max = criterias.asset_size_max;
		this.criterias.asset_size_min = criterias.asset_size_min;
		this.criterias.employee_size_max = criterias.employee_size_max;
		this.criterias.employee_size_min = criterias.employee_size_min;
		this.criterias.plan_participants_max = criterias.plan_participants_max;
		this.criterias.plan_participants_min = criterias.plan_participants_min;
		this.criterias.zip_code = criterias.zip_code;
		this.criterias.radius = criterias.radius;

		this.criteriaService.saveCampaignCriteria(this.criterias, this.campaign.id).subscribe((data: any) => {
			this.toastSrv.show('Criteria saved correctly', 'Success');
			this.getcriterias();
		});
	}

	//table criteria
	getCellClassOptions({ row, column, value }): any {
		return {
			' cellForButtons back-cell-text-left': row['id'] > 0,
		};
	}

	getCriteriaStates() {
		this.criteriaService.getCampaignCriteriaStates(this.campaign.id).subscribe((data: any) => {
			this.rowsStates = data.body;
		});
	}

	removeState(state: any) {
		Swal.fire({
			title: `Message`,
			text: `Are you sure you want to remove?`,
			showCancelButton: true,
			confirmButtonText: 'Yes',
		}).then((data) => {
			if (data.value) {
				const payload = {
					state: state,
					campaign_id: this.campaign.id,
				};
				this.criteriaService.deleteCriteriaState(payload).subscribe((data: any) => {
					this.getCriteriaStates();
					this.getcriterias();
				});
			}
		});
	}

	saveCriteriaState() {
		const criterias = this.formCriteria.getRawValue();
		this.criteriaService.saveCriteriaState(this.campaign.id, criterias.state, this.campaign.prospects_type).subscribe((data: any) => {
			this.utils.swal('Success', 'success', 'State added correctly');
			this.formCriteria.get('state').reset();
			this.formCriteria.get('state').setValue('');
			this.getCriteriaStates();
		});
	}

	getStateName(state: string) {
		return this.states.find((s) => s.shortName == state).name;
	}
}
